<template>

  <el-drawer custom-class="shift_edit_modal" v-model="modalVisible" :title="dialogTitle" @open="openModal"
    @close="closeModal" destroy-on-close :append-to-body="true" :direction="'btt'">

    <template v-if="shift?.shiftApplications?.length > 0 ">
      <div class="search-bar-wrap">
        <input v-model="searchTerm" type="text" placeholder="Search by name..."
          class="search-input search-input--custom" />
        <button @click="clearSearchTerm" v-if="searchTerm" class="clear-button">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.33335 15.8334L4.16669 14.6667L8.83335 10L4.16669 5.33335L5.33335 4.16669L10 8.83335L14.6667 4.16669L15.8334 5.33335L11.1667 10L15.8334 14.6667L14.6667 15.8334L10 11.1667L5.33335 15.8334Z"
              fill="rgb(var(--locumate-clr-gray-light))" />
          </svg>

        </button>
      </div>
      <div class="locum-count-selected" v-if="selectedApplicants.length > 0 ">
        Selected {{ selectedApplicants.length }} locum.
      </div>
      <template v-if="filteredShiftApplications.length > 0">
        <div class="applicant-list">
          <div class="avatar-row" v-for="(locumItem, i) in filteredShiftApplications" v-bind:key="locumItem.id">
            <div class="avatar-row-left">
              <el-checkbox class="c-label" :checked="isSelected(locumItem.id)"
                @change="handleCheckboxChange(locumItem.id)"></el-checkbox>
              <template v-if="locumItem.locum">
                <el-avatar :size="'small'" shape="circle" :src="locumItem.locum.image"
                  v-if="locumItem.locum.image != null" @click="actions.applicantInfoModalOpen(locumItem, i)" />
                <el-avatar :size="'small'" class="avatar-d" shape="circle"
                  icon="locumate_icons locumate_icon-user1 locumate_icons-avatar"
                  @click="actions.applicantInfoModalOpen(locumItem, i)" v-else></el-avatar>
              </template>
              <p>
                <span style="font-size: 25px;">{{ locumItem.locum?.name || 'Unknown locum' }}</span><br>
                <span class="text-secondary" style="font-size: 15px;">
                  Locum rate: ${{ locumItem.locumRate }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="non-locum">
          Unfortunately, the searched locum could not be found. Please check the information and try again.
        </div>

      </template>


    </template>
    <template v-else>
      There are no applicants for this shift.
    </template>
    <!-- <template #footer> -->
    <div class="sub-outer">
      <el-button class="submit_page sub" type="blue" @click="actions.bulkOffer(job, i)"
        :disabled="selectedApplicants.length == 0">
        Offer
      </el-button>
      <el-button class="submit_page danger" type="red" @click="actions.bulkDecline(job, i)"
        :disabled="selectedApplicants.length == 0">
        Decline
      </el-button>
    </div>

    <!-- </template> -->
  </el-drawer>

  <modal-user-info :modalName="'applicantInfoModal'" :options="applicantInfoModal"></modal-user-info>
</template>
  
  <script>
  import { ref, inject,computed } from "vue";
  import moment from "moment";
  import { useStore } from "vuex";
  import { ElMessageBox,ElMessage } from "@/components/Vendor/Element";
  import { useRouter } from "vue-router";
import { ApplicantInfoModal } from "../modals";
  export default {
    props: {
      modalName: {
        type: String,
      },
      options: {
        type: Object,
      },
    },
    components: {
      "modal-user-info": ApplicantInfoModal,
    },
    setup(props) {
      const $store = useStore();
      const $router = useRouter();
      const $mitt = inject("$mitt");
      const $modals = inject("$modals");
      const modalVisible = ref(false);
      const bottomDropUp = ref([]);
      const userData = $store.getters.GET_USER_DATA;
      const userRole = userData.role; 
      const $moment = inject(["$moment"]);
      const selectedApplicants = ref([]);
      const searchTerm = ref("");
      // const showAwardShiftDialog = ref(false);
      const closeModal = () => {
        modalVisible.value = false;
      };
      $mitt.on(props.modalName, (options) => {
        modalVisible.value = options.show;
      });
      // const openModal = () => {};
      const dialogTitle = computed(() => {
        return `${checkJobDateStart(job.value.startDate, job.value.endDate, true)}`;
      // if (checkJobDateStart(job.value.startDate, job.value.endDate)) {
      //   return `${checkJobDateStart(job.value.startDate, job.value.endDate, true)} - ${moment(job.value.endDate, "YYYY/MM/DD").format("D MMM")}`;
      // } else {
      //   return moment(job.value.endDate, "YYYY/MM/DD").format("D MMM");
      // }
    });

    const filteredShiftApplications = computed(() => {
      const searchLowerCase = searchTerm.value.toLowerCase();
      const apps = shift.value?.shiftApplications;
      if (!Array.isArray(apps)) {
        return [];
      }
      return apps.filter((locumItem) =>
        locumItem.locum?.name?.toLowerCase().includes(searchLowerCase)
      );
    });

    const applicantInfoModal = ref({
      name: "userInfo",
      user: {},
    });

    const handleCheckboxChange = (applicantId) => {
      const index = selectedApplicants.value.indexOf(applicantId);
      if (index === -1) {
        selectedApplicants.value.push(applicantId);
      } else {
        selectedApplicants.value.splice(index, 1);
      }
    };

    const isSelected = (applicantId) => {
      return selectedApplicants.value.includes(applicantId);
    };

    const actions = {
      applicantInfoModalOpen(locumObj) {
          bottomDropUpClose();
          applicantInfoModal.value.user = locumObj.locum;
          $modals.open("applicantInfoModal");
      },
      bulkOffer(job,i){
       
       if(selectedApplicants.value.length > 1){
        ElMessageBox.alert("Multiple applicants have been assigned while offering bulk shift. Kindly review and choose only a single applicant.", "Error", {
        showCancelButton: false,
        confirmButtonText: "Close",
        confirmButtonClass: "el-button--red",
      });
       }else{
        // bottomDropUpClose(i);
        
        let startDate = checkJobDateStart(job.startDate, job.endDate, true);
      let endDate = $moment(job.endDate, "YYYY/MM/DD").format("D MMM");
        console.log("🚀 ~ file: BlockApplicationsPreviewModal.vue:179 ~ bulkOffer ~ endDate:", endDate);
        (async () => {
          try {
            await ElMessageBox.confirm(
              `Are you sure you’d like to offer bulk applicants for ${startDate} shift?`,
              "Offer Bulk Applicants",
              {
                confirmButtonText: "Offer",
                cancelButtonText: "Cancel",
                confirmButtonClass: "el-button--blue",
                cancelButtonClass: "secondary",
                showClose: false,
              }
            );
            await (async () => {
              try {
                bottomDropUpClose(i);
                closeModal();
                await $store.dispatch("BULK_OFFER", {
                    application_ids: selectedApplicants.value,
                  });

                  const jobResponse = await $store.dispatch("GET_JOB_INFO_DETAILS", {
                                jobId: job.id,
                                params: {
                                    with:
                                        "pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,locum,locum.settings,locum.address,shifts.pharmacy,shifts.pharmacy.settings,shifts.pharmacy.address,shifts.pharmacy.files,shifts.locum,shifts.locum.settings,shifts.locum.address,abilities,config.hours_before_shift_lock,settings,agency,shifts.agency, shifts.shiftApplications",
                                },
                            });
                            console.log("🚀 ~ file: ApplicationsPreviewModal.vue:251 ~ await ~ job:", jobResponse)
                        
                            $store.dispatch('clearJobDetails');
                            $store.dispatch("setJobDetails", {
                                job: jobResponse.data,
                            });

                ElMessage({
                  type: "success",
                  message: "All Applicants offered successfully",
                });
                selectedApplicants.value = [];
                $router.push({
                    name: "job_days",
                });

              } catch (error) {
                ElMessage({
                  type: "info",
                  message: "All Applicants did not offered",
                });
                console.log("error submit!!",error);
              }
            })();
          } catch (error) {
            console.log(error);
          }
        })();
       }
      
      },
      bulkDecline(job,i){
      let startDate = checkJobDateStart(job.startDate, job.endDate, true);
      // let endDate = $moment(job.endDate, "YYYY/MM/DD").format("D MMM");
        (async () => {
          try {
            await ElMessageBox.confirm(
              `Are you sure you’d like to decline bulk applicants for ${startDate} shift.`,
              "Decline Bulk Applicants",
              {
                confirmButtonText: "Decline",
                cancelButtonText: "Cancel",
                confirmButtonClass: "el-button--red",
                cancelButtonClass: "el-button--grey",
                showClose: false,
              }
            );
            await (async () => {
              try {
                bottomDropUpClose(i);
                closeModal();
                await $store.dispatch("BULK_DECLINE", {
                    application_ids: selectedApplicants.value,
                  });

                  const jobResponse = await $store.dispatch("GET_JOB_INFO_DETAILS", {
                                jobId: job.id,
                                params: {
                                    with:
                                        "pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,locum,locum.settings,locum.address,shifts.pharmacy,shifts.pharmacy.settings,shifts.pharmacy.address,shifts.pharmacy.files,shifts.locum,shifts.locum.settings,shifts.locum.address,abilities,config.hours_before_shift_lock,settings,agency,shifts.agency, shifts.shiftApplications",
                                },
                            });
                            console.log("🚀 ~ file: ApplicationsPreviewModal.vue:251 ~ await ~ job:", jobResponse)
                        
                            $store.dispatch('clearJobDetails');
                            $store.dispatch("setJobDetails", {
                                job: jobResponse.data,
                            });

                ElMessage({
                  type: "success",
                  message: "Applicant(s) has been declined",
                });
                selectedApplicants.value = [];
                $router.push({
                    name: "job_days",
                });

               
              } catch (error) {
                ElMessage({
                  type: "info",
                  message: "All Applicants did not declined",
                });
                console.log("error submit!!",error);
              }
            })();
          } catch (error) {
            console.log(error);
          }
        })();
      },
    }
      const checkJobDateStart = (dateStart, endDate, trim) => {
        console.log('erklerkelr');
        let start = moment(dateStart, "YYYY/MM/DD");
        let end = moment(endDate, "YYYY/MM/DD");
        if (start.format("MMMM") == end.format("MMMM")) {
          if (start.format("D") == end.format("D")) {
            return start.format("D " + (trim ? "MMM" : "MMMM"));
          }
          return (
          start.format("D ") +
          " - " +
          end.format("D " + (trim ? "MMM" : "MMMM"))
        );
        } else {
          return (
            start.format("D " + (trim ? "MMM" : "MMMM")) +
            " - " +
            end.format("D " + (trim ? "MMM" : "MMMM"))
          );
        }
    };

    const job = computed(() => {
      return props.options.job;
    });
    console.log("🚀 ~ file: BlockApplicationsPreviewModal.vue:204 ~ job ~ job:", job)

    const shift = computed(() => {
      const jobShifts = props.options?.job?.shifts;
      if (Array.isArray(jobShifts) && jobShifts.length > 0) {
        return jobShifts[0];
      }
      return { shiftApplications: [] };
    });

    const bottomDropUpClose = (i) => {
      bottomDropUp.value[i] = false;
    };


    const openModal = () => {
      // no-op — applicants come from job.shifts supplied by the parent
    };

    const clearSearchTerm = () => {
      searchTerm.value = "";
    };

      return {
        closeModal,
        modalVisible,
        openModal,
        checkJobDateStart,
        job,
        shift,
        bottomDropUp,
        dialogTitle,
        userData,
        userRole,
        bottomDropUpClose,
        applicantInfoModal,
        actions,
        handleCheckboxChange,
        selectedApplicants,
        isSelected,
        filteredShiftApplications,
        searchTerm,
        clearSearchTerm
      };
    },
  };
  </script>
